module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel stats",
    style: (_vm.gridItemStyles)
  }, [_c('div', {
    staticClass: "panel-header"
  }, [_c('h3', [_vm._v(_vm._s(_vm.widget.title))])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [(_vm.widgetComponent) ? _c(_vm.componentName, {
    tag: "component",
    attrs: {
      "series": _vm.series,
      "layout": _vm.widgetComponent.layout
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f32978e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/DashboardWidget.vue
// module id = 624
// module chunks = 0